<section class="axis-drivers" [style.height]="'100%'">
  <header class="axis-drivers__header">
    <div class="axis-drivers__eyebrow" *ngIf="eyebrow">{{ eyebrow }}</div>
    <h3 class="axis-drivers__title" *ngIf="sectionTitle">{{ sectionTitle }}</h3>
  </header>

  <div class="axis-drivers__state" *ngIf="loading">Loading</div>
  <div class="axis-drivers__state axis-drivers__state--error" *ngIf="!loading && errorMessage">
    {{ errorMessage }}
  </div>

  <div class="axis-drivers__list" *ngIf="!loading && !errorMessage">
    <div
      class="axis-drivers__row"
      *ngFor="let row of rows; trackBy: trackByRow"
      (mouseenter)="handleRowMouseEnter(row, $event)"
      (mousemove)="handleRowMouseMove(row, $event)"
      (mouseleave)="handleRowMouseLeave(row)"
      [class.axis-drivers__row--hoverable]="getHoverChartConfig(row)"
    >
      <div
        class="axis-drivers__label"
        (mouseenter)="handleLabelMouseEnter(row, $event)"
        (mousemove)="handleLabelMouseMove(row, $event)"
        (mouseleave)="handleLabelMouseLeave(row)"
      >
        <span class="axis-drivers__label-text">{{ row.label }}</span>
        <span class="axis-drivers__update" *ngIf="getUpdateLabel(row)">
          {{ getUpdateLabel(row) }}
        </span>
      </div>
      <div class="axis-drivers__status">
        <div class="axis-drivers__badge" [ngStyle]="getStatusStyle(getDisplayStatus(row))">
          {{ getDisplayStatus(row) }}
        </div>
      </div>
    </div>

    <div class="axis-drivers__state" *ngIf="!rows.length">No driver data available.</div>
  </div>

  <div
    #hoverCard
    class="axis-drivers__hover-card"
    *ngIf="activeHoverConfig"
    [ngStyle]="activeHoverStyle"
    [class.axis-drivers__hover-card--market-share]="activeHoverConfig?.type === 'market-share-progress' && activeHoverConfig?.compact !== false"
    [class.axis-drivers__hover-card--auto-size]="activeHoverConfig?.popupAutoSize || activeHoverConfig?.popupHeight === 'auto'"
    [class.axis-drivers__hover-card--noninteractive]="activeHoverConfig?.popupInteractive === false"
    (mouseenter)="handleHoverCardMouseEnter()"
    (mouseleave)="scheduleHideHoverChart()"
  >
    <ng-container [ngSwitch]="activeHoverConfig?.type">
      <div class="axis-drivers__hover-tooltip" *ngSwitchCase="'tooltip'">
        <div class="axis-drivers__hover-tooltip-title" *ngIf="activeHoverConfig?.title">
          {{ activeHoverConfig?.title }}
        </div>
        <div class="axis-drivers__hover-tooltip-description" *ngIf="activeHoverConfig?.description">
          {{ activeHoverConfig?.description }}
        </div>
        <div class="axis-drivers__hover-tooltip-state" *ngIf="hoverTooltipLoading">Loading...</div>
        <div class="axis-drivers__hover-tooltip-state axis-drivers__hover-tooltip-state--error" *ngIf="!hoverTooltipLoading && hoverTooltipError">
          {{ hoverTooltipError }}
        </div>
        <div class="axis-drivers__hover-tooltip-note" *ngIf="!hoverTooltipLoading && hoverTooltipError && hoverUnavailableNote">
          {{ hoverUnavailableNote }}
        </div>
        <div class="axis-drivers__hover-tooltip-value" *ngIf="!hoverTooltipLoading && !hoverTooltipError && hoverTooltipValue">
          {{ hoverTooltipValue }}
        </div>
      </div>
      <div class="axis-drivers__hover-loading" *ngIf="activeHoverConfig?.type !== 'tooltip' && hoverChartLoading">
        Loading...
      </div>
      <div class="axis-drivers__hover-empty" *ngIf="activeHoverConfig?.type !== 'tooltip' && !hoverChartLoading && hoverChartError">
        <div class="axis-drivers__hover-empty-message">{{ hoverChartError }}</div>
        <div class="axis-drivers__hover-empty-note" *ngIf="hoverUnavailableNote">{{ hoverUnavailableNote }}</div>
      </div>
      <app-cagr-hover-chart
        *ngSwitchCase="'cagr-hover-chart'"
        [style.display]="hoverChartLoading || hoverChartError ? 'none' : 'block'"
        [data]="activeHoverConfig"
      ></app-cagr-hover-chart>
      <app-tree-map-chart
        *ngSwitchCase="'treemap-chart'"
        [style.display]="hoverChartLoading || hoverChartError ? 'none' : 'block'"
        [data]="activeHoverConfig"
        [widgetId]="activeHoverConfig?.widgetId"
      ></app-tree-map-chart>
      <app-market-share-progress
        *ngSwitchCase="'market-share-progress'"
        [style.display]="hoverChartLoading || hoverChartError ? 'none' : 'block'"
        [data]="activeHoverConfig"
      ></app-market-share-progress>
      <app-mixed-stackbar-chart
        *ngSwitchDefault
        [style.display]="hoverChartLoading || hoverChartError ? 'none' : 'block'"
        [data]="activeHoverConfig"
      ></app-mixed-stackbar-chart>
    </ng-container>

    <div class="axis-drivers__hover-progress-wrap" *ngIf="shouldShowRowProgress(activeHoverRow) && !hoverChartLoading && !hoverChartError">
      <div class="axis-drivers__progress" [ngStyle]="getRowProgressTrackStyle(activeHoverRow)">
        <ng-container *ngIf="!isSalesProgressRow(activeHoverRow) && hasRowProgressScaleLabels(activeHoverRow)">
          <span
            *ngFor="let label of getRowProgressScaleLabels(activeHoverRow)"
            class="axis-drivers__progress-scale"
            [class.axis-drivers__progress-scale--start]="label.edgeClass === 'start'"
            [class.axis-drivers__progress-scale--end]="label.edgeClass === 'end'"
            [class.axis-drivers__progress-scale--middle]="label.edgeClass === 'middle'"
            [ngStyle]="getRowProgressScaleLabelStyle(label)"
          >
            {{ label.text }}
          </span>
        </ng-container>
        <ng-container *ngIf="!isSalesProgressRow(activeHoverRow) && !hasRowProgressScaleLabels(activeHoverRow)">
          <span
            class="axis-drivers__progress-scale axis-drivers__progress-scale--start"
            *ngIf="getRowProgressStartLabel(activeHoverRow)"
          >
            {{ getRowProgressStartLabel(activeHoverRow) }}
          </span>
          <span
            class="axis-drivers__progress-scale axis-drivers__progress-scale--end"
            *ngIf="getRowProgressEndLabel(activeHoverRow)"
          >
            {{ getRowProgressEndLabel(activeHoverRow) }}
          </span>
        </ng-container>
       <span
          class="axis-drivers__progress-reference"
          *ngIf="getRowProgressReferenceLabel(activeHoverRow)"
          [ngStyle]="getRowProgressReferenceStyle(activeHoverRow)"
        >
          {{ getRowProgressReferenceLabel(activeHoverRow) }}
        </span>
       <span
          class="axis-drivers__progress-reference"
          *ngIf="getRowProgressSecondaryReferenceLabel(activeHoverRow)"
          [ngStyle]="getRowProgressSecondaryReferenceStyle(activeHoverRow)"
        >
          {{ getRowProgressSecondaryReferenceLabel(activeHoverRow) }}
        </span>
        <span class="axis-drivers__progress-segment axis-drivers__progress-segment--weak"></span>
        <span class="axis-drivers__progress-segment axis-drivers__progress-segment--fair"></span>
        <span class="axis-drivers__progress-segment axis-drivers__progress-segment--good"></span>
        <span
          class="axis-drivers__progress-marker"
          [ngClass]="getRowProgressMarkerClasses(activeHoverRow)"
          [ngStyle]="getRowProgressMarkerStyle(activeHoverRow)"
        ></span>
        <span
          class="axis-drivers__progress-marker-value"
          [ngClass]="getRowProgressMarkerValueClasses(activeHoverRow)"
          *ngIf="getRowProgressMarkerValueLabel(activeHoverRow)"
          [ngStyle]="getRowProgressMarkerValueStyle(activeHoverRow)"
        >
          {{ getRowProgressMarkerValueLabel(activeHoverRow) }}
        </span>
        <span
          *ngFor="let label of getSalesProgressBoundaryLabels(activeHoverRow)"
          class="axis-drivers__sales-boundary-label"
          [class.axis-drivers__sales-boundary-label--start]="label.edgeClass === 'start'"
          [class.axis-drivers__sales-boundary-label--middle]="label.edgeClass === 'middle'"
          [class.axis-drivers__sales-boundary-label--end]="label.edgeClass === 'end'"
          [ngStyle]="getSalesProgressBoundaryLabelStyle(label)"
        >
          {{ label.text }}
        </span>
      </div>
      <div class="axis-drivers__progress-footer-label" *ngIf="getRowProgressFooterLabel(activeHoverRow)">
        {{ getRowProgressFooterLabel(activeHoverRow) }}
      </div>
    </div>
  </div>
</section>
